export const ScheduleChangeConsentEmployerRoutes = [
    {
        "url": "/schedule-change-consent?brand_id&from_date&to_date",
        "name": "appLayout.schedule.schedule-change-consent",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            "body": {
                "component": "consentsListEmployerContainer"
            }
        },
        "params": {
            brand_id: {
                dynamic: true
            },
            from_date: {
                dynamic: true
            },
            to_date: {
                dynamic: true
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["schedule_change_consent"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/schedule-change-consent/schedule-change-consent.downgrade.module");
                }
            }
        ]
    }
];
//# sourceMappingURL=schedule-change-consent-employer.routes.js.map